module.exports = __webpack_public_path__ + "static/media/lingmingshan5.537f7b85.webp";